import Vue from 'vue'
import Router from 'vue-router'

import {
  getUser
} from '@/utils/auth'

//apps
import Dashboard from '../views/apps/Dashboard.vue'

// modules
import autentications from './modules/autentications'
import administration from './modules/administration'
import inputOutputAjust from './modules/inputOutputAdjust'

//pages
import Configuration from '@/views/pages/configuration/Configuration.vue'
import Profile from '../views/pages/Profile.vue'
import Invoice from '../views/pages/Invoice.vue'
import Thirds from '../views/pages/thirds/Index.vue'

//errors
import errors from './modules/errors'

import layouts from '../layout'
import store from '../store'
import reports from './modules/reports'
import product from './modules/product'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: '/admin',
  routes: [{
      path: '/',
      redirect: '/adjust_input',
      alias: '/dashboards',
      name: 'Inicio',
      component: Dashboard,
      meta: {
        auth: true,
        nav: true,
        layout: layouts.navLeft,
        searchable: true,
        tags: ['Inicio'],
        roles: ['admin', 'deposit'],
        icon: 'gauge'
      }
    },
    {
      path: '/thirds',
      name: 'Terceros',
      component: Thirds,
      meta: {
        auth: true,
        nav: true,
        layout: layouts.navLeft,
        searchable: true,
        tags: ['Terceros'],
        roles: ['admin','deposit'],
        icon: 'account-group-outline'
      }
    },
    product,
    inputOutputAjust,
    {
      path: '/profile',
      name: 'Perfil',
      component: Profile,
      meta: {
        auth: true,
        layout: layouts.navLeft,
        searchable: false,
        tags: ['Perfil'],
        roles: ['admin', 'deposit'],
        icon: 'account-card-details',
      }
    },
    {
      path: '/invoice',
      name: 'Factura',
      component: Invoice,
      meta: {
        auth: true,
        layout: layouts.navLeft,
        searchable: false,
        tags: ['Factura'],
        roles: ['admin', 'deposit'],
        icon: 'file-document'
      }
    },
    {
      path: '/logout',
      beforeEnter(to, from, next) {
        auth.logout()
        next({
          path: '/login'
        })
      }
    },
    reports,
    administration,
    autentications,
    {
      path: '/configuration',
      name: 'Configuración',
      component: Configuration,
      meta: {
        auth: true,
        nav: false,
        layout: layouts.navLeft,
        searchable: true,
        tags: ['Configuración'],
        roles: ['admin'],
        icon: 'cogs'
      }
    },
    errors,
  ]
})


const l = {
  contenOnly() {
    store.commit('setLayout', layouts.contenOnly)
  },
  navLeft() {
    store.commit('setLayout', layouts.navLeft)
  },
  navRight() {
    store.commit('setLayout', layouts.navRight)
  },
  navTop() {
    store.commit('setLayout', layouts.navTop)
  },
  navBottom() {
    store.commit('setLayout', layouts.navBottom)
  },
  set(layout) {
    store.commit('setLayout', layout)
  }
}

//insert here login logic
const auth = {
  loggedIn() {
    return store.getters.isLogged
  },
  logout() {
    store.commit('setLogout')
  },
  user() {
    return getUser()
  },
}

router.beforeEach((to, from, next) => {
  let authrequired = false
  if (to && to.meta && to.meta.auth)
    authrequired = true

  if (authrequired) {
    if (auth.loggedIn()) {
      if (to.name === 'login') {
        // window.location.href = '/admin'
        window.location.href = '/admin/adjust_input'
        return false
      } else {

        if (!to.meta.roles) {
          next()
          return false
        }
        let enter = false
        for (var i = 0; i < auth.user().roles.length; i++) {
          // console.log(auth.user().roles[i], to.meta.roles);
          if (to.meta.roles.includes(auth.user().roles[i].guard_name)) {
            // window.location.href = '/admin/' + auth.user().roles[i].guard_name
            enter = true
          }
        }
        if (!enter)
          next({
            name: 'Unauthorized'
          })

        next()
      }
    } else {
      if (to.name !== 'login') {
        window.location.href = '/admin/login'
        return false
      }
      next()
    }
  } else {
    if (auth.loggedIn() && to.name === 'login') {
      // window.location.href = '/admin'
      window.location.href = '/admin/adjust_input'
      return false
    } else {
      next()
    }
  }

  if (to && to.meta && to.meta.layout) {
    l.set(to.meta.layout)
  }
})

router.afterEach((to, from) => {
  setTimeout(() => {
    store.commit('setSplashScreen', false)
  }, 500)
})

export default router
